import math from '@/utils/math'

const DOMAIN = process.env.NODE_ENV === 'production'
  ? location.hostname.substring(0, location.hostname.indexOf('.'))
  : 'shop-nijisanji-niji-dev1'
const ENV = DOMAIN.slice(DOMAIN.lastIndexOf('-') + 1)
const HOST_ENV = (ENV === 'dev1' || ENV === 'dev2' || ENV === 'dev3' || ENV === 'dev4' || ENV === 'stg' || ENV === 'mig')
  ? ENV + '.' : ''
const HOST = `https://${DOMAIN}.api.ccs.${HOST_ENV}groovy-ec.com`

export const IS_DEMO_MODE = DOMAIN === 'no_use'

// 認証
export const AUTH_URL = HOST + '/auth'
// 認証トークン再発行
export const AUTH_TOKEN_URL = HOST + '/auth/token'
// 認証 シングルサイン
export const AUTH_SSO_URL = HOST + '/auth/sso'
export const AUTH_SSO_CONFIG_URL = HOST + '/auth/sso/config'

// 二段階認証
export const AUTH_MFA_GA = HOST + '/auth/mfa/ga/'

// GraphQL
export const GRAPH_QL_URL = HOST + '/graphql'

// ポイント
export const POINT_URL = HOST + '/point'
// ポイント計算
export const POINT_BY_ORDER_URL = HOST + '/point/byorder'

// 注文更新
export const ORDER_URL = HOST + '/order'
// 注文記録
export const ORDER_NOTE_URL = HOST + '/order/note'
// 出荷指図
export const ORDER_EXPORT_URL = HOST + '/order/export'
// 臨時出荷指図
export const ORDER_EXTRA_EXPORT_URL = HOST + '/order/export/extra'
// 注文CSVダウンロード
export const ORDER_DOWNLOAD_URL = HOST + '/order/download_order'

// O-PLUXイベント更新
export const OPLUX_EVENT_URL = HOST + '/fraud/oplux/event'

// アカウント
export const ACCOUNT_URL = HOST + '/account'
// ロール
export const ROLE_URL = HOST + '/account/role'
// サイトロール
export const ROLE_SITE_URL = HOST + '/account/role/site'
// 権限ロール
export const ROLE_PERMISSION_URL = HOST + '/account/role/permission'

// ダウンロードファイル作成
export const DOWNLOAD = HOST + '/misc/download'
// ダウンロード署名付きURL取得
export const GET_DOWNLOAD_URL = HOST + '/misc/download_url'

// アップロード
export const UPLOAD = HOST + '/misc/upload'

// 署名付きURL取得
export const GET_S3_SIGNED_URL = HOST + '/misc/signed_url'

// 支払処理
export const PAYMENT_URL = HOST + '/payment'

// 商品
export const PRODUCT_URL = HOST + '/product'

// 商品画像
export const PRODUCT_IMAGE_URL = HOST + '/product/image'

// 商品カラー
export const PRODUCT_COLOR_URL = HOST + '/product/color'

// 商品カラーグループ
export const PRODUCT_COLORGROUP_URL = HOST + '/product/colorGroup'

// 商品サイズ
export const PRODUCT_SIZE_URL = HOST + '/product/size'
// 商品サイズグループ
export const PRODUCT_SIZEGROUP_URL = HOST + '/product/sizeGroup'

// EC配分在庫移動API
export const EC_STOCK = HOST + '/stock/ec'

// EC在庫アラート処理
export const EC_STOCK_ALERT = HOST + '/stock/ec/alert'

// 在庫調整更新API
export const EC_STOCK_ADJUSTMENT = HOST + '/stock/adjustment'

// 在庫移動指示更新API
export const EC_STOCK_MOVE = HOST + '/stock/move'

// 出荷先マスタ更新API
export const EC_STOCK_DESTINATION = HOST + '/stock/destination'

// メール通知
export const MAIL_NOTIFY = HOST + '/mail/sns_notify'

// 検索条件設定
export const SEARCH_CONDITION_URL = HOST + '/account/searchCondition/config'

// 表示項目設定
export const DISPLAY_ITEM = HOST + '/account/displayItem/config'

// 出荷配送休業日
export const SHIP_LOGISTICSCALENDAR_URL = HOST + '/ship/logisticsCalendar'

// メールテンプレート
export const MAIL_TEMPLATE_URL = HOST + '/mail/template'

// 保留設定
export const PENDING_URL = HOST + '/misc/pending'

// 保留条件指定商品更新API
export const PENDING_PRODUCT_URL = HOST + '/misc/pendingProduct'
// 決済ログ
export const REPORT_PAYMENT_URL = HOST + '/report/payment'

// 販売売上レポート
export const REPORT_SALES_URL = HOST + '/report/sales'

// cookie 利用 (0: false, 1: true)
export const COOKIE = 0

// リクエストタイムアウト(ms)
export const REQUEST_TIMEOUT = 60 * 1000

// ローカルストレージデータの有効期間日数
export const LOCAL_STORAGE_EXPIRATION_DAYS = 30

// 注文 既定設定
export const ORDER_CONFIG = {
  quantity: {
    decimalDigit: 0,
    roundType: math.ROUND
  },
  price: {
    decimalDigit: 0,
    roundType: math.ROUND
  },
  tax: {
    decimalDigit: 0,
    roundType: math.ROUND
  }
}

/**
 * 商品情報
 */
// 使用する場合は適切な内容に変更が必要
export const PRODUCT_API_URL = 'https://xxxxxxxxxx.execute-api.ap-northeast-1.amazonaws.com/prd/api/'
